import { render, staticRenderFns } from "./consumptionPoints.vue?vue&type=template&id=061ff7ca&"
import script from "./consumptionPoints.vue?vue&type=script&lang=js&"
export * from "./consumptionPoints.vue?vue&type=script&lang=js&"
import style0 from "./consumptionPoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports